/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { SwapX2YModule__factory } from "./SwapX2YModule__factory";
